import fetch from './fetch.js'
import 'whatwg-fetch'
import braintree from 'braintree-web'
// import Bugsnag from '@bugsnag/js'
var form = document.querySelector('.js-submit-booking')
var cardDetails = document.querySelector('.js-card-details')
var paymentSelectionButtons = document.querySelector('.js-payment-selection')
var applePayButton = document.querySelector('.apple-pay-button')
var cardSelectButton = document.querySelector('.js-select-card')
let applePayAvailable = false
import 'whatwg-fetch'
const $userForm = document.querySelector('.js-user-details')
const $travelForm = document.querySelector('.js-travel-details')
const $travelSection = document.querySelector('.js-travel-section')
const $paymentSection = document.querySelector('.js-payment-section')
const $paymentForm = document.querySelector('.js-payment-details')
let changingPromo = false

function init() {
  setupAddButtons()

  if (!cardSelectButton) return

  cardSelectButton.addEventListener('click', setupDebitCardPayment)

  if (
    window.ApplePaySession &&
    ApplePaySession.supportsVersion(3) &&
    ApplePaySession.canMakePayments()
  ) {
    applePayAvailable = true
    setupApplePay()
    applePayButton.classList.remove('hidden')
  }

  $paymentForm.addEventListener('submit', (_) => {
    $paymentForm.querySelector('[type=submit] .js-spinner').hidden = false
  })

  setupPaymentSelection()

  additionalValidation()

  document.querySelectorAll('.js-apply-cancellation-waiver').forEach(function(checkbox) {
    checkbox.addEventListener('change', function(event) {
      const setWaiver = event.target.checked;
      
      toggleCancellationWaiver(setWaiver);
    })
  })

  document.querySelectorAll('.js-remove-cancellation-waiver').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      toggleCancellationWaiver(false);

      document.getElementById('set_waiver').checked = false;
    })
  })
}

function additionalValidation() {
  document.querySelectorAll('input[type="tel"]').forEach(function (input) {
      input.addEventListener('input', function () {
          // Prevent spaces and letters
          this.value = this.value.replace(/[^0-9\+]/g, '');
      });
  });
}

function toggleCancellationWaiver(add = true) {
  fetch('/book/parking/toggle-cancellation-waver', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.getElementById('waiver-csrf').value
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      set_waiver: add,
    }),
  })
    .then((res) => res.json())
    .then((response) => {
      if (response.waiver === true) {
        document.querySelector('.js-cancellation-waiver-cart-item').classList.remove('hidden');
      } 

      if (response.waiver === false) {
        document.querySelector('.js-cancellation-waiver-cart-item').classList.add('hidden');
      }

      if ('price' in response) {
        document.querySelector('.js-cancellation-waiver-cart-item__price').innerHTML = '£' + response.price;
      }

      if ('cart_total' in response) {
        document.querySelector('.js-cart-total').innerHTML = '£' + response.cart_total;
        document.getElementById('submit-booking').innerHTML = 'Book and Pay £' + response.cart_total;

        // Update LBA.cart.total
        LBA.cart.total = response.cart_total
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function setupPaymentSelection() {
  if (!applePayAvailable) {
    return setupDebitCardPayment()
  }
}

function selectPaymentMethod(paymentMethod) {
  if (paymentMethod === 'card') {
    setupDebitCardPayment()
  }
}

function enableButtons() {
  document.querySelector('.js-details-form-submit').disabled = false
  $paymentForm.querySelector('[type=submit] .js-spinner').hidden = true
}

function disableButtons() {
  document.querySelector('.js-details-form-submit').disabled = true
}

function setupDebitCardPayment() {
  let threeDSecure;
  let deviceData;

  paymentSelectionButtons.classList.add('hidden')
  paymentSelectionButtons.classList.remove('flex')

  cardDetails.classList.remove('hidden')

  braintree.client.create(
    {
      authorization: LBA.cart.authorization,
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        let e = new Error('BrainTree Client Creation Error', { cause: clientErr })

        Bugsnag.notify(e)

        // Handle error in client creation
        return
      }

      braintree.dataCollector.create({
        client: clientInstance,
        kount: true,
      }, function (err, dataCollectorInstance) {
        if (err) {
          console.error(err);
          return;
        }

        document.getElementById('device_data').value = dataCollectorInstance.deviceData;


        console.log('deviceData', dataCollectorInstance);
      });

      braintree.threeDSecure.create(
        {
          client: clientInstance,
          version: 2,
        },
        function (threeDSecureErr, threeDSecureInstance) {
          if (threeDSecureErr) {
            // Handle error in 3D Secure component creation
            let e = new Error('BrainTree 3D Secure Error', { cause: threeDSecureErr })
            Bugsnag.notify(e)

            return
          }

          threeDSecure = threeDSecureInstance
        }
      )

      var d = new Date()

      var options = {
        client: clientInstance,
        styles: {
          input: {
            'font-family': 'roboto, verdana, sans-serif',
            'font-size': '15px',
            'font-weight': 'normal',
          },
          '.valid': {
            color: 'green',
            border: '1px solid green',
          },
          ':focus': {
            color: 'black',
            border: '1px solid black',
          },
          '.invalid': {
            color: 'red',
            border: '1px solid red',
          },
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '',
          },
          cvv: {
            selector: '#cvv',
            placeholder: 'CVV',
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YYYY',
          },
        },
      }

      braintree.hostedFields.create(
        options,
        function (hostedFieldsErr, hostedFieldsInstance) {
          if (hostedFieldsErr) {
            let e = new Error('BrainTree Hosted Fields Error', { cause: hostedFieldsErr })

            Bugsnag.notify(e)
            // Handle error in Hosted Fields creation
            return
          }

          $paymentForm.addEventListener(
            'submit',
            function (event) {
              event.preventDefault()

              let $form = event.target
              let method = $form.method || 'POST'
              let body = new window.FormData($form)

              let consent = body.get('marketing-consent')

              if (!consent) {
                continuePayment()
              } else {
                fetch('/newsletter/subscribe', {
                  method,
                  body: JSON.stringify({
                    name: body.get('FirstName') + ' ' + body.get('LastName'),
                    email: body.get('EmailAddress'),
                  }),
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                  },
                }).then(continuePayment)
              }

              function continuePayment() {
                if (changingPromo) {
                  return $paymentForm.submit()
                }

                disableButtons()

                hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                  if (tokenizeErr) {
                    let e = new Error('BrainTree Tokenize Error', { cause: tokenizeErr })

                    Bugsnag.notify(e)

                    enableButtons()
                    document.querySelector('.card-errors').style.display =
                      'block'
                    return
                  } else {
                    disableButtons()
                  }

                  threeDSecure.verifyCard(
                    {
                      amount: LBA.cart.total,
                      nonce: payload.nonce,
                      bin: payload.details.bin,
                      collectDeviceData: true,
                      email: body.get('EmailAddress'),
                      billingAddress: {
                        phoneNumber: body.get('PhoneNumber'),
                        givenName: body.get('FirstName'),
                        surname: body.get('LastName'),
                      },
                      additionalInformation: {
                        ipAddress: body.get('ip_address'),
                      },
                      onLookupComplete: function (data, next) {
                        next()
                      }
                    },
                    function (err, response) {
                      if (err) {
                        let e = new Error('BrainTree 3D Verify Error', { cause: err })

                        Bugsnag.notify(e)

                        enableButtons()
                        document.getElementById('3ds-verify-errors').style.display = 'block';
                      }

                      document.getElementById('payment_nonce').value = response.nonce

                      $paymentForm.submit()
                    }
                  )
                })
              }
            },
            false
          )
        }
      )
    }
  )
}

function setupApplePay() {
  braintree.client.create(
    {
      authorization: LBA.cart.authorization,
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        let e = new Error('BrainTree Client Creation Error (Apple Pay)', { cause: clientErr })

        Bugsnag.notify(e)

        // Handle error in client creation
        return
      }

      braintree.applePay.create(
        {
          client: clientInstance,
        },
        function (applePayErr, applePayInstance) {
          if (applePayErr) {
            let e = new Error('BrainTree Apple Pay Creation Error', { cause: applePayErr })

            Bugsnag.notify(e)    

            console.error('Error creating applePayInstance:', applePayErr)
            return
          }

          // Alternatively, check if the device has an Apple Pay card available.
          // You can do this if your checkout flow defaults to Apple Pay
          // or if you are displaying Apple Pay buttons on a product detail page.

          // Use your Apple Pay merchant identifier
          // to check if payments can be made.

          applePayButton.addEventListener('click', function (event) {
            var paymentRequest = applePayInstance.createPaymentRequest({
              total: {
                label: 'Total Amount',
                amount: LBA.cart.total,
              },

              // We recommend collecting billing address information, at minimum
              // billing postal code, and passing that billing postal code with
              // all Apple Pay transactions as a best practice.
              requiredBillingContactFields: ['postalAddress'],
            })
            console.log(paymentRequest.countryCode)
            console.log(paymentRequest.currencyCode)
            console.log(paymentRequest.merchantCapabilities)
            console.log(paymentRequest.supportedNetworks)

            var session = new ApplePaySession(3, paymentRequest)

            session.onvalidatemerchant = function (event) {
              applePayInstance.performValidation(
                {
                  validationURL: event.validationURL,
                  displayName: 'Leeds Bradford Airport',
                },
                function (err, merchantSession) {
                  if (err) {
                    // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                    return
                  }
                  session.completeMerchantValidation(merchantSession)
                }
              )
            }

            session.onpaymentauthorized = function (event) {
              console.log(
                'Your shipping address is:',
                event.payment.shippingContact
              )

              applePayInstance.tokenize(
                {
                  token: event.payment.token,
                },
                function (tokenizeErr, payload) {
                  if (tokenizeErr) {
                    console.error('Error tokenizing Apple Pay:', tokenizeErr)
                    session.completePayment(ApplePaySession.STATUS_FAILURE)
                    return
                  }

                  // Send payload.nonce to your server.
                  console.log('nonce:', payload.nonce)

                  // If requested, address information is accessible in event.payment
                  // and may also be sent to your server.
                  console.log(
                    'billingPostalCode:',
                    event.payment.billingContact.postalCode
                  )

                  // After you have transacted with the payload.nonce,
                  // call `completePayment` to dismiss the Apple Pay sheet.
                  session.completePayment(ApplePaySession.STATUS_SUCCESS)

                  document.querySelector('.payment_nonce').value = payload.nonce

                  console.log(document.querySelector('.payment_nonce').value)

                  $paymentForm.submit()
                }
              )
            }

            session.begin()
          })
        }
      )
    }
  )
}

function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent('on' + etype)
  } else {
    var evObj = document.createEvent('Events')
    evObj.initEvent(etype, true, false)
    el.dispatchEvent(evObj)
  }
}

function setupAddButtons() {
  const $quantitySelects = Array.from(
    document.querySelectorAll('.js-quantity-select')
  )
  $quantitySelects.forEach(($quantitySelect) => {
    let $selects = Array.from($quantitySelect.querySelectorAll('select'))
    $selects.forEach(($select) => {
      $select.addEventListener('change', (e) => {
        let button = $quantitySelect.querySelector('button[type=submit]')
        let count = 0

        $selects.forEach(($updatedQuantitySelect) => {
          count += parseInt($updatedQuantitySelect.value)
        })

        button.disabled = count === 0
        button.style.opacity = count === 0 ? 0.5 : 1
      })

      eventFire($select, 'change')
    })
  })

  const $products = Array.from(document.querySelectorAll('.js-product-id'))
  const $fastTrack = document.querySelector('.js-fast-track-id')
  const $fastTrackButton = document.querySelector('.js-fast-track-add')

  if ($products && $fastTrack && $fastTrackButton) {
    let count = $products.filter(
      ($product) =>
        $product.getAttribute('data-product-id') === $fastTrack.value
    ).length

    if (count > 0) {
      $fastTrackButton.disabled = true
      $fastTrackButton.style.opacity = 0.5
    }
  }
}

init()



// WEBPACK FOOTER //
// ./src/js/_cart.js